import { classNames } from "@/utility/jsx";
import type { HTMLAttributes, PropsWithChildren } from "react";
import style from "./style.module.scss";

export const FooterPanel = ({ children, ...props }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => (
  <div {...props} className={classNames(style["footer-panel"], props.className)}>
    {children}
  </div>
);
